import { Component, OnInit } from '@angular/core';
import {LoginManager} from '../../_managers/login-manager.services'
import { Router, NavigationEnd } from '@angular/router';
import {  Subscription } from 'rxjs';
import { User } from './../../_models/sesion/user';

@Component({
  selector: 'app-principal-layout',
  templateUrl: './principal-layout.component.html',
  styleUrls: ['./principal-layout.component.scss']
})
export class PrincipalLayoutComponent implements OnInit {
  private refNativagate = new Subscription();
  currentUser:User;
  constructor(private router: Router, private loginManager: LoginManager) { }

  ngOnInit() {
    /*this.validateLogin();
    this.refNativagate = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.validateLogin();
      }
    });*/
    this.loginManager.currentUser.subscribe(x => this.currentUser = x);
  }


  validateLogin() {
    let login=this.loginManager.isLogin();
    if (!login) {
      this.router.navigate(['/login']);
    }
  }

}
